import SmCard from './sm_card.vue'

SmCard.install = function(Vue){  
    Vue.component(SmCard.name, SmCard)
}  

export default SmCard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/smart_webview_ui/src/components/sm_card/index.js
// module id = null
// module chunks = 